import NewLoginTemplate from '/src/com/yext/platform/users/js/newloginhelpers/newlogintemplate';
import {registerComponentForJsonDataWithUIKit} from '/ui/lib/easyuikit';
import {yext} from '/ui/lib/msg';

const {Box, Text, Link} = require('@yext/mana-ui');

/**
 * Component to render the invalid set password link page
 */
export function InvalidSetPasswordLink({whitelabelInfo}) {
  return (
    <NewLoginTemplate
      title={yext.msg('Reset Password')}
      subtitle={yext.msg('Invalid Reset Password Link')}
      cardContent={<CardContent whitelabelInfo={whitelabelInfo} />}
      whitelabelInfo={whitelabelInfo}
    />
  );
}

function CardContent({whitelabelInfo}) {
  return (
    <Box>
      <Text fontSize={'sm'} fontWeight={'medium'}>
        {yext.msg('The link you clicked is expired.')}
      </Text>
      <br />
      <Text fontSize={'sm'}>
        {yext.msg('If you know your password, ')}
        <Link
          as={'a'}
          href={'/users/login'}
          palette={'primary'}
          size={'sm'}
          style={{whiteSpace: 'nowrap'}}
          flexShrink={0}
        >
          {yext.msg('log in now.')}
        </Link>
      </Text>
      <br />
      <Text fontSize={'sm'}>
        {yext.msg('If not, try again to ')}
        <Link
          as={'a'}
          href={'/users/forgotpassword'}
          palette={'primary'}
          size={'sm'}
          style={{whiteSpace: 'nowrap'}}
          flexShrink={0}
        >
          {yext.msg('reset your password.')}
        </Link>
      </Text>
    </Box>);
}

document.addEventListener('DOMContentLoaded', () => {
  registerComponentForJsonDataWithUIKit('InvalidSetPasswordLink', InvalidSetPasswordLink);
});
